import getAPI from "@API/index";

export const postNewCode = (body, history) => {
  const newBody = {
    code: body.code.trim(),
    RequestAmount: body.RequestAmount,
  };

  return (dispatch) => {
    getAPI()
      .request({
        method: "post",
        url: `/api/code`,
        data: newBody,
      })
      .then(() => {
        history.goBack();
      });
  };
};
